import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

class FeferenceQuote extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    show = (record = {}) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
        });
    }

    loadData = () => {
        const { record, pagination } = this.state;
        const { evaluateRecordId } = record;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.evaluate.queryListForConsult,
            data: { 
                offset: current,
                limit: pageSize,
                evaluateRecordId, 
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: datas,
                    loading: false,
                    pagination,
                })
            }
        };
        $.sendRequest(options);
    }

    showViewPage = (record) => {
        const { evaluateRecordId, evaluateCode, quotationType } = record;
        sessionStorage.evaluateRecordId = evaluateRecordId;
        sessionStorage.evaluateCode = evaluateCode;
        sessionStorage.quotationType = quotationType;
        window.open(`./#/clinicalEvaluation/ViewPage`);
    }

    getColumns = () => [{
        title: '临床评估单号',
        dataIndex: 'evaluateCode',
        key: 'evaluateCode',
        width: 100,
        render: (text, record) => <a onClick={ () => this.showViewPage(record)}>{text}</a>
    }, {
        title: '方案编号',
        dataIndex: 'evaluateSerialNumber',
        key: 'evaluateSerialNumber',
        width: 100,
    }, {
        title: '项目分期',
        dataIndex: 'investigationByStageNames',
        key: 'investigationByStageNames',
        width: 120,
    }, {
        title: '随机病例数',
        dataIndex: 'randomCaseNum',
        key: 'randomCaseNum',
        width: 120,
    }, {
        title: '启动中心数',
        dataIndex: 'startSiteNum',
        key: 'startSiteNum',
        width: 120,
    }, {
        title: 'PM',
        dataIndex: 'pmName',
        key: 'pmName',
        width: 120,
    }]

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { visible, loading, data, record, pagination } = this.state;
        const { lineOfBusinessString, investigationAreaName, diseaseName, researchProductTypeName } = record;
        return (
            <Modal
                title="参考评估"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                maskClosable={false}
                width="1000px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div className="cont-cont contract-record" style={{margin: 20}}>
                    <div style={{ marginBottom: 16 }}>
                        业务线：{lineOfBusinessString}
                        <span className="ant-divider" />
                        适应症：{diseaseName}
                        <span className="ant-divider" />
                        治疗领域：{investigationAreaName}
                        <span className="ant-divider" />
                        研究产品类型：{researchProductTypeName}
                    </div>
                    <div>
                        <TableC
                            data={data}
                            loading={loading}
                            columns={this.getColumns()}
                            pagination={pagination}
                            onChange={this.handleTableChange}
                        />
                        <div style={{ position: 'relative', top: -1, borderTop: '1px solid #e4e4e4' }} />
                    </div>
                </div>
            </Modal>
        );
    }
}

export default FeferenceQuote;


// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/FeferenceQuote.js